import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    const savedToken = localStorage.getItem('adminToken');
    if (savedToken) {
      try {
        // 设置axios默认header
        axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
        
        // 验证token是否有效
        await axios.get('/api/admin/verify');
        setIsAdmin(true);
        setToken(savedToken);
      } catch (error) {
        // Token无效，清除
        logout();
      }
    }
    setLoading(false);
  };

  const login = (newToken) => {
    localStorage.setItem('adminToken', newToken);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setIsAdmin(true);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    delete axios.defaults.headers.common['Authorization'];
    setIsAdmin(false);
    setToken(null);
  };

  const value = {
    isAdmin,
    loading,
    token,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};